<template>
  <div class="biscuet-container">
    <div
      id="inspire"
      :style="bAppStyle"
    >
      <UpdateNotification />
      <ClientExpiredNotification />
      <BLayout>
        <UserHeader />
        <Sidebar />
        <FilterControlPanel v-if="$route.name === 'LeadList'" />
        <RouterView :key="routerViewKey" />
      </BLayout>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ClientExpiredNotification from '@/components/organisms/ClientExpiredNotification.vue';
import UpdateNotification from '@/components/organisms/UpdateNotification.vue';
import FilterControlPanel from '@/components/organisms/user/leadList/filter/FilterControlPanel.vue';
import Sidebar from '@/components/organisms/user/Sidebar.vue';
import UserHeader from '@/components/organisms/user/UserHeader.vue';

export default defineComponent({
  name: 'User',
  components: {
    FilterControlPanel,
    Sidebar,
    UserHeader,
    UpdateNotification,
    ClientExpiredNotification,
  },
  computed: {
    bAppStyle() {
      return {
        width: '100%',
      };
    },
    // NOTE: リードリストはクエリ（callTargetId / leadViewId / currentPage）の変化をwatchで拾って
    // 反映しているため、再マウントの必要がない。他ページはwatchが無くcreated()の再実行に依存しているので
    // 従来どおりfullPathで再マウントさせる。
    // FIXME: 他ページにもwatchを入れてkey自体を廃止したい（vue-router公式はkeyでなくwatchを推奨）
    routerViewKey(): string {
      return this.$route.name === 'LeadList' ? this.$route.path : this.$route.fullPath;
    },
  },
});
</script>

<style lang="scss" scoped>
.biscuet-container {
  @include m-fixed-height(100vh);
  display: flex;
  position: relative;
  max-width: 100%;
  overflow: hidden;
}
</style>
